import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import i18n from '~/plugins/i18n'
import App from '~/components/App'

import '~/plugins'
import '~/components'

import Vuetify from 'vuetify'
import SequentialEntrance from 'vue-sequential-entrance'
import VueClip from 'vue-clip'
import VueMomentLib from 'vue-moment-lib'

import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify, {
  iconfont: 'fa'
})
Vue.use(SequentialEntrance)
Vue.use(VueClip)
Vue.use(VueMomentLib)

Vue.moment.locale(window.locale,
  {
    relativeTime: window.locale === 'nl' ? {
      future: 'in %s',
      past: '%s geleden',
      s: 'enkele ogenblikken ',
      ss: '%d seconden',
      m: 'een minuut',
      mm: '%d minuten',
      h: 'een uur',
      hh: '%d uur',
      d: 'een dag',
      dd: '%d dagen',
      M: 'een maand',
      MM: '%d maanden',
      y: 'een jaar',
      yy: '%d jaren'
    } : {
      future: 'dans %s',
      past: 'il y a %s',
      s: 'quelques instants ',
      ss: '%d secondes',
      m: 'une minute',
      mm: '%d minutes',
      h: 'une heure',
      hh: '%d heures',
      d: 'un jour',
      dd: '%d jours',
      M: 'un mois',
      MM: '%d mois',
      y: 'un an',
      yy: '%d ans'
    }
  }
)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  i18n,
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./resources/js/app.js